import { configFetch as fetch } from '@meiqia/utils';
import { ENV_CONFIG } from '@meiqia/constants';

const ticketApiUrl = ENV_CONFIG.TICKET_API_URL;

export const getMarketingInfoApi = () => {
  return fetch({
    url: '/plan/marketing/status',
    method: 'get'
  });
};

export const getTicketInfoApi = () => {
  return fetch({
    baseURL: ticketApiUrl,
    url: '/balance/find_one',
    method: 'get'
  });
};
